import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "sonner";
import { CreditCard, Loader2, CheckCircle2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export default function PayBooking() {
  const { id } = useParams();
  const [b, setB] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get(`/bookings/${id}/payment`).then((r) => setB(r.data)).catch((e) => setErr(formatApiError(e?.response?.data?.detail) || "Booking not found"));
  }, [id]);

  const pay = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/checkout/booking/${id}`, { origin_url: window.location.origin });
      window.location.href = data.url;
    } catch (e) { toast.error(formatApiError(e?.response?.data?.detail) || "Couldn't start payment"); setBusy(false); }
  };

  if (err) return <div className="p-8 text-sm text-[#FF4500]" data-testid="pay-booking-error">{err}</div>;
  if (!b) return <div className="p-8 text-sm text-[#A3A3A3] inline-flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" /> Loading…</div>;
  const owed = b.payment_status === "awaiting_payment" && b.status !== "cancelled";
  return (
    <div className="max-w-lg card-surface p-6 space-y-4" data-testid="pay-booking-page">
      <div className="label-mono text-[#CCFF00]">YOUR BOOKING</div>
      <h1 className="h-display text-3xl">{b.title}</h1>
      <div className="text-sm text-[#E5E5E5]">
        {b.start ? new Date(b.start).toLocaleString("en-GB", { weekday: "long", day: "numeric", month: "long", hour: "2-digit", minute: "2-digit" }) : ""}
        {b.venue ? ` · ${b.venue}` : ""}{b.coach_name ? ` · with ${b.coach_name}` : ""}
      </div>
      {owed ? (
        <button type="button" onClick={pay} disabled={busy} data-testid="pay-booking-btn"
          className="btn-volt px-5 py-3 text-sm inline-flex items-center gap-2 disabled:opacity-50">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <CreditCard className="w-4 h-4" />} Pay £{Number(b.price || 0).toFixed(2)}
        </button>
      ) : (
        <div className="text-sm text-[#22C55E] inline-flex items-center gap-2" data-testid="pay-booking-settled"><CheckCircle2 className="w-4 h-4" /> Nothing to pay — you're all set.</div>
      )}
      <Link to="/calendar" className="block text-xs uppercase tracking-wider text-[#A3A3A3] hover:text-white">Go to my calendar</Link>
    </div>
  );
}
